



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class AppRefreshAndExport extends Vue {
  @Prop({ type: Function }) readonly refreshHandler!: Function;
  @Prop({ type: Function }) readonly exportHandler!: Function;

  handleRefresh () {
    if (this.refreshHandler) {
      this.refreshHandler()
    }
  }

  handleExport () {
    if (this.exportHandler) {
      this.exportHandler()
    }
  }
}
